<template lang="pug">
v-system-bar.px-4(v-if='model', app='', color='#262626', theme='dark', height='58')
  a.d-flex.align-center(
    href='https://vuetifyjs.com/?ref=vtyd-pro-demo-system-bar',
    target='_blank'
  )
    base-img.mr-2(
      alt='Vuetify Logo',
      contain='',
      src='https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png',
      width='32',
      height='32',
      sizes='32px'
    )
    base-img.hidden-xs-only(
      alt='Vuetify Name',
      contain='',
      width='96',
      height='24',
      sizes='96px',
      src='https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png'
    )
  v-spacer
  v-btn.text-capitalize.text-subtitle-2(
    color='success',
    href='https://store.vuetifyjs.com/products/zero-theme-pro/?ref=vtyd-system-bar',
    min-width='112'
  )
    | Buy It Now
  v-divider.ml-6.mr-3(vertical='')
  v-btn.text-capitalize.system-bar-dismiss.mr-n2.mr-sm-n1(
    size='small'
    variant='text'
    @click='model = false'
  )
    v-icon(color='white', start)
      | mdi-close
    span.hidden-xs-only
      | Remove Frame
</template>

<script setup>
defineOptions({
  name: 'HomeSystemBar',
})

const model = ref(false)
</script>

<style scoped>
.system-bar-dismiss {
  color: rgba(255, 255, 255, 0.86);
}
</style>
